import { render } from "./LottieAnimationEditorCmp.vue?vue&type=template&id=5aa7566a"
import script from "./LottieAnimationEditorCmp.vue?vue&type=script&lang=js"
export * from "./LottieAnimationEditorCmp.vue?vue&type=script&lang=js"

import "./LottieAnimationEditorCmp.vue?vue&type=style&index=0&id=5aa7566a&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__